// src/components/layout.js
// Shared page-width container, matches navbar's max-w-screen-xl + p-4.
const Layout = ({ children, className = "" }) => {
  return (
    <div className={`max-w-screen-xl mx-auto px-4 ${className}`}>
      {children}
    </div>
  );
};

export default Layout;